/**
 * @fileOverview This file contains the implementation of the hook to manage the tour/tutorial in Users module.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Typography } from "@mui/material";
import { useTranslationHook } from "../hooks/UseTranslationHook";

const useUsersTour = (setModalUShow) => {
  const {
    usersS1P1,
    usersS1P2,
    usersS2P1,
    usersS2P2,
    usersS3P1,
    usersS3P2,
    usersS3P3,
    usersS3P4,
    usersS3P5,
    usersS4P1,
    usersS4P2,
    usersS5P1,
    usersS5P2,
  } = useTranslationHook();

  return [
    {
      selector: ".create-user-tour",
      content: (
        <Typography>
          <strong>{usersS1P1}</strong> {usersS1P2}
        </Typography>
      ),
      action: () => setModalUShow(false),
      stepInteraction: false,
    },
    {
      selector: ".create-user-tour",
      content: (
        <Typography>
          {usersS2P1} <strong>{usersS2P2}</strong>.
        </Typography>
      ),
      action: () => setModalUShow(true),
      stepInteraction: false,
    },
    {
      selector: ".create-user-form-tour",
      content: (
        <Typography>
          {usersS3P1} <strong>{usersS3P2}</strong>. {usersS3P3}{" "}
          <strong>{usersS3P4}</strong> {usersS3P5}
        </Typography>
      ),
      action: () => setModalUShow(true),
      stepInteraction: false,
    },
    {
      selector: ".users-datagrid-tour",
      content: (
        <Typography>
          {usersS4P1} <strong>{usersS4P2}</strong>.
        </Typography>
      ),
      action: () => setModalUShow(false),
      stepInteraction: false,
    },
    {
      selector: ".users-datagrid-actions-tour",
      content: (
        <Typography>
          {usersS5P1} <strong>{usersS5P2}</strong>.
        </Typography>
      ),
      action: () => setModalUShow(false),
      stepInteraction: false,
    },
  ];
};

export default useUsersTour;
